import axios from 'axios';
import UPDATE_LOGO from '../actions/actionTypes';
import { LightenDarkenColor } from '../components/utils';

const initialState = {
  logoUrl: '',
};

const setConfig = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_LOGO:
      return {
        ...state,
        logoUrl: action.logoUrl,
      };
    default:
      return state;
  }
};

async function setSettings() {
  let response = await axios.get('/accounts/settings.json');
  response = response.data;
  response.created_at = new Date();
  localStorage.setItem('peephole_settings', JSON.stringify(response));

  return response;
}

export async function updateLogo(dispatch) {
  let response = await setSettings();
  const peepholeSettings = localStorage.getItem('peephole_settings');

  if (peepholeSettings) {
    response = JSON.parse(peepholeSettings);

    if (moment(response.created_at).diff(moment(), 'minutes') < -10) {
      response = await setSettings();
    }
  }

  const root = document.documentElement;

  root.style.setProperty('--ph-color-1', response.primary_background_color);
  root.style.setProperty('--ph-color-2', response.secondary_background_color);
  root.style.setProperty('--ph-color-3', response.primary_text_color);
  root.style.setProperty('--ph-color-4', response.secondary_text_color);
  root.style.setProperty('--ph-top-color', response.top_color);

  root.style.setProperty(
    '--ph-color-1-dark',
    LightenDarkenColor(response.primary_background_color, 20),
  );
  root.style.setProperty(
    '--ph-color-2-dark',
    LightenDarkenColor(response.secondary_background_color, -10),
  );

  dispatch({ type: UPDATE_LOGO, logoUrl: response.logo_url });
}

export default setConfig;
